import BookingDetailsPage from '../../shared/booking/BookingDetailsPage';
import { packageRefund } from './data';
import PackageSummary from './PackageSummary';

export default function PackageBookingDetails() {
  return (
    <BookingDetailsPage
      module="packages"
      Summary={PackageSummary}
      refLabel="Holiday reference"
      refund={packageRefund}
      policy={[
        'More than 30 days before departure: 10% cancellation charge.',
        '15–30 days before departure: 50% cancellation charge.',
        'Less than 15 days before departure: non-refundable.',
        'TCS collected on international packages is always refunded.',
      ]}
    />
  );
}
